import { MDBContainer, MDBRow } from 'mdb-react-ui-kit'
import { Outlet } from 'react-router'

import { ProjectBanner } from './ProjectsBanner/ProjectsBanner'
// import React from 'react'

export function Projects() {

    return (
        <>
            <MDBContainer className={'border border-0 border-danger'}>
                <MDBRow className={'border border-0 border-success mb-5'}>
                    <ProjectBanner />
                </MDBRow>
                <MDBContainer className={'border border-0 border-success mb-5'}>
                    <MDBRow className={'border border-0 border-success'} >
                        <Outlet />
                    </MDBRow>
                </MDBContainer>
            </MDBContainer>
        </>
    )
}